import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const EstructuraOperativa = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/organigrama-operacional.pdf`;
  /*const pdfUrl = "/pdf/organigrama-operacional.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Organigrama Operacional</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Organigrama Operacional" />
      </Container>
    </>
  );
};

 export default EstructuraOperativa;
